export default (url) => {
  if(!document.cachedImages) {
    document.cachedImages=[];
  }
  const img = new Image();
  img.src = url;
  document.cachedImages.push(img);
  return url;
};
